webpackJsonp([3],{

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {
  // inject bloomerang script
  (function (d, script) {
    var bloomerangID = $('#modal-donation-form').attr('data-bloomerang-id');
    var scriptURL = 'https://s3-us-west-2.amazonaws.com/bloomerang-public-cdn/orphangraintrain/.widget-js/' + bloomerangID + '.js';

    script = d.createElement('script');
    script.type = 'text/javascript';
    script.async = 'true';
    script.src = scriptURL;
    script.onload = function () {
      return removeLoadAnimOnFormInject();
    };
    var formContainer = d.getElementsByClassName('modal-form-inject')[0];
    formContainer.insertBefore(script, formContainer.firstChild);
  })(document);

  function removeLoadAnimOnFormInject() {
    // form was injected successfully by bloomerang
    if ($('#donation-form-container').length > 0) {
      // get rid of loader anim
      $('.modal-form-inject .loading-container').remove();

      return true;
    } else {
      // no injection yet, check again..
      setTimeout(removeLoadAnimOnFormInject, 50);
    }
  }

  // Read URL and check for ?donate param, launch modal if present
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('donate')) {
    $('[data-modal="modal-donation-form"]').trigger('modal:show');
  }
});

/***/ })

},[150]);


// WEBPACK FOOTER //
// donation-modal.40247ef7.js